import _ from 'lodash'
import { baseURL, formatFetchError, fetchHeaders } from '@/api/util'
import { Api, Stat } from '@cruz-com/lookup'

export const estimateVehicleValue = {
  getMakes,
  getModels,
  getYears,
  getTrims,
  search,
}

async function getMakes(): Promise<Api.Result<string[]>> {
  try {
    const res = await fetch(`${baseURL}/research/vehicle-value/makes`, {
      method: 'GET',
      headers: await fetchHeaders(),
    })
    const d: Api.Result<string[]> = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

async function getModels(make: string): Promise<Api.Result<string[]>> {
  try {
    const res = await fetch(`${baseURL}/research/vehicle-value/models?make=${encodeURIComponent(make)}`, {
      method: 'GET',
      headers: await fetchHeaders(),
    })
    const d: Api.Result<string[]> = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

async function getYears(make: string, model: string): Promise<Api.Result<number[]>> {
  try {
    const res = await fetch(`${baseURL}/research/vehicle-value/years?make=${encodeURIComponent(make)}&model=${encodeURIComponent(model)}`, {
      method: 'GET',
      headers: await fetchHeaders(),
    })
    const d: Api.Result<number[]> = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

async function getTrims(make: string, model: string, year: string | number): Promise<Api.Result<string[]>> {
  try {
    const res = await fetch(`${baseURL}/research/vehicle-value/trims?make=${encodeURIComponent(make)}&model=${encodeURIComponent(model)}&year=${year}`, {
      method: 'GET',
      headers: await fetchHeaders(),
    })
    const d: Api.Result<string[]> = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}

async function search(params: object): Promise<Api.Result<Stat.VehicleValue[]>> {
  try {
    const { make, model, year } = params as Record<string, string>
    if (!make || !model || !year) {
      return Promise.resolve({ meta: {}, data: [] })
    }
    const res = await fetch(`${baseURL}/research/vehicle-value/search?${new URLSearchParams(params as Record<string, string>)}`, {
      method: 'GET',
      headers: await fetchHeaders(),
    })
    const d: Api.Result<Stat.VehicleValue[]> = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}